var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"height":"100%"},attrs:{"align":"center"}},[_c('db-map',{attrs:{"is-form":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }